module.exports = __webpack_public_path__ + "static/WEDDING E&M-533-9bcf8a7dfcbd68a83f3bbb7454c47e21.jpg";